export const refreshLoadedAccountPages = (pages = []) => {
  const loadedPages = [...new Set(pages)]
    .filter((page) => page?.loaded && typeof page.reload === "function");
  return Promise.allSettled(loadedPages.map(async (page) => page.reload()));
};

export default refreshLoadedAccountPages;
